import { Injectable }     from '@angular/core';
import { APP_CONFIG }     from '@appConfig/_app-config_master';
import { APP_MODE }       from '@appConfig/app-mode-config';
import { LocaleEnum }     from '@models/language';
import { ToasterService } from '@shared/services/toaster.service';
import { UiService }      from '@shared/services/ui.service';
import { DateUtils }      from '@utils/helpers/index';

@Injectable( { providedIn: 'root' } )
export class DateUtilsHelperService {

	/** Prevention of overload by developer popups errors which are possible while date format (when string used by mistake) */
	private dateToasterTimeout;

	constructor(
		private readonly toaster: ToasterService,
		private readonly uiService: UiService
	) { }

	getLocaleDateString( date: Date, options?: Intl.DateTimeFormatOptions, spare: string = '' ): string {
		if ( !date ) { return spare; }

		const locale: LocaleEnum = this.uiService.getLanguage() as LocaleEnum;

		// sanitization log only for developers - timeout because of refreshing templates
		// string will be converted in utils
		if ( typeof date === 'string' && APP_CONFIG.appMode === APP_MODE.LOCAL ) {
			if ( this.dateToasterTimeout ) { clearTimeout( this.dateToasterTimeout ); }
			this.dateToasterTimeout = setTimeout( () => {
				clearTimeout( this.dateToasterTimeout );
				this.toaster.error( 'ERROR! Unexpected incoming date format (string)!' );
			}, 300 );
		}

		return DateUtils.getLocaleDateString( date, locale, options );
	}
}
